import { FontAwesome5 } from '@expo/vector-icons';
import { styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import SelectDropdownInputBase, {
  SelectDropdownInputBaseProps,
} from './select-dropdown-input-base';
import type { DropdownItemType } from './select-dropdown-input.types';
import { OEText } from '../../atoms/oe-text/oe-text';

export interface SelectDropdownInputCustomProps
  extends SelectDropdownInputBaseProps {}

const SelectDropdownInputCustom = React.forwardRef<
  any,
  SelectDropdownInputCustomProps
>((inputProps, ref) => {
  const renderDropdownIcon = () => (
    <IconArrow color={inputProps.arrowColor} name="sort-down" />
  );

  const renderSelectedButtonText = (selectedItem: DropdownItemType): any => {
    return (
      <OEText fontSize={16} fontType="regular" numberOfLines={1}>
        {selectedItem.value}
      </OEText>
    );
  };

  return (
    <Dropdown
      {...inputProps}
      ref={ref}
      buttonTextAfterSelection={renderSelectedButtonText}
      renderDropdownIcon={renderDropdownIcon}
    />
  );
});

const Dropdown = styled(SelectDropdownInputBase).attrs(
  ({
    theme,
    buttonStyle,
    buttonTextStyle,
    dropdownStyle,
    rowStyle,
    rowTextStyle,
  }) => ({
    buttonStyle: [
      {
        borderRadius: 4,
      },
      buttonStyle,
    ] as StyleProp<ViewStyle>,
    buttonTextStyle: [
      {
        fontFamily: theme.secondaryFont.regular.fontFamily,
        fontSize: 16,
      },
      buttonTextStyle,
    ] as StyleProp<ViewStyle>,
    dropdownStyle: [
      {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
      },
      dropdownStyle,
    ] as StyleProp<ViewStyle>,
    rowStyle,
    rowTextStyle: [
      {
        fontFamily: theme.secondaryFont.regular.fontFamily,
      },
      rowTextStyle,
    ] as StyleProp<ViewStyle>,
  })
)``;

const IconArrow = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  size: 16,
}))`
  margin-right: 10px;
  margin-bottom: 10px;
`;

export default memo(SelectDropdownInputCustom);
